module.exports = __webpack_public_path__ + "img/share_chapter_mengxiang@2x.e85bf4ed.png";